module.exports = __webpack_public_path__ + "img/check_icon.7fa23501.png";